import { render, staticRenderFns } from "./DataPanel.vue?vue&type=template&id=1686d020&scoped=true&"
import script from "./DataPanel.vue?vue&type=script&lang=js&"
export * from "./DataPanel.vue?vue&type=script&lang=js&"
import style0 from "./DataPanel.vue?vue&type=style&index=0&id=1686d020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686d020",
  null
  
)

export default component.exports